export const skillsData = [
  {
    id: 1,
    name: "PHP",
    rating: "80",
  },
  {
    id: 2,
    name: "Codeigniter",
    rating: "80",
  },
  {
    id: 3,
    name: "HTML",
    rating: "70",
  },
  {
    id: 4,
    name: "CSS",
    rating: "70",
  },

  {
    id: 5,
    name: "Bootstrap",
    rating: "70",
  },
  {
    id: 6,
    name: "JavaScript",
    rating: "80",
  },
  {
    id: 7,
    name: "Jquery",
    rating: "80",
  },
  {
    id: 8,
    name: "ReactJS",
    rating: "50",
  },
  {
    id: 9,
    name: "NodeJs",
    rating: "60",
  },
  {
    id: 10,
    name: "MySQL",
    rating: "70",
  },
  {
    id: 11,
    name: "MongoDb",
    rating: "60",
  },
  {
    id: 12,
    name: "Firebase",
    rating: "30",
  },

  {
    id: 13,
    name: "Git",
    rating: "70",
  },
];
